
//import data from "./articles/demo";
//import data from "./articles/miljopartiet";
//import data from "./articles/brexit";
//import data from "./articles/hedersmord";
//import data from "./articles/test";
//import data from "./articles/hyrestestet";
//import data from "./articles/hyrestestet-tack";
//import data from "./articles/zika";
//import data from "./articles/zikatimeline";
//import data from "./articles/historien-om-zika";
//import data from "./articles/flight";
//import data from "./articles/utslapp";
//import data from "./articles/efterflykten-bakgrund";
// import data from "./articles/kulturkartan-kommunala-kultursatsningar-2015";
// import data from "./articles/estland-fentanyl";
// import data from "./articles/vem-sa-vad-i-tredje-presidentvals-debatten";
//import data from "./articles/brexit";
//import data from "./articles/min-van-tiggaren";
//import data from "./articles/airbus-a320";
//import data from "./articles/en-hel-by-tystnar";
//import data from "./articles/krisen-i-miljopartiet";
//import data from "./articles/gammal-bil";
//import data from "./articles/efter-flykten";
//import data from "./articles/efterflykten-bakgrund";
//import data from "./articles/efter-flykten-mottagandet";
//import data from "./articles/efter-flykten-jobben";
//import data from "./articles/efter-flykten-skolan";
//import data from "./articles/dammolyckan-i-brasilien";
// import data from "./articles/fem-ar-efter-otoya";
// import data from "./articles/is-fore-efter";
// import data from "./articles/usagrafik";
// import data from "./articles/usa-swingstates";
import data from "./articles/usa-valnatt-grafik";
export default data;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/index.js
 **/